import { Col, Row } from "antd";
import { BELIEVE_IMAGE } from "assets";

import "./styles.scss";

const BelieveSection = () => {
  return (
    <section className="believe-section">
      <div className="believe-section-inner container">
        <img src={BELIEVE_IMAGE} alt="believe-image" />
        <Row className="believe-text" align={"middle"}>
          <Col xs={24} md={12}>
            <h2 className="bt-heading">
              At Agape IT, we believe in the transformative power of technology
              infused with empathy
            </h2>
          </Col>
          <Col xs={24} md={12}>
            <p className="bt-desc jakarta-sans-font text-black-subtle">
              Our journey began a decade ago, in the United Kingdon, fueled by a
              vision to create meaningful connections through innovative IT
              solutions. Here’s our story:
            </p>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default BelieveSection;
